<template>
    <div id="result_list">
        <div class="position-relative">
            <!--轮播图-->
            <scroll-carousel :homeScroll="brandScroll" class="screenH" />
            <header>
                <div class="brandWith d-center-between">
                    <span @click="RouteTo(brandId + '','tabRooms')">客房</span>
                    <span @click="RouteTo(brandId + '','tabActi')">活动</span>
                    <span @click="RouteTo(brandId + '','tabDing')">餐饮</span>
                    <span @click="RouteTo(brandId + '','tabMeets')">会议室</span>
                    <span @click="RouteTo(brandId + '','tabItinerary')">线路行程</span>
                </div>
            </header>
        </div>
        <div class="brandWith">
            <div class="mt-5 mb-5 text-left" v-html="BrandInfo.intro"></div>
            <!--评论信息-->
            <user-comments class="mt-5"/>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import ScrollCarousel from '../IndexPage/ScrollCarousel'
import UserComments from '.././DetailWrap/UserComments'
export default {
    name: 'HalfMountainWater',
    components: {ScrollCarousel,UserComments},
    data () {
        return {
            brandScroll: []
        }
    },
    computed: {
        ...mapState(['BrandInfo']),
        ...mapGetters(['isGroup','storeInfo']),
    },
    watch: {
        BrandInfo (newVal) {
            let arr = this.BrandInfo.banner_pic.split(',')
            let newArr = arr.map(item => {
                return {pic: item}
            })
            this.brandScroll = newArr
        }
    },
    mounted(){
        this.getBrand()
    },
    methods: {
        ...mapActions(['GetHotelList']),
        RouteTo(type,name) {
            let changeRoute = this.$router.resolve('/index_brand/brand_detail/' + type + '/' + name);
            window.open(changeRoute.href, '_blank');
        },
        getBrand(){
            this.GetHotelList({
                type: 'brand',
                data: { brandhall_id: this.brandId },
                el: '#result_list',
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.brandWith{
    width: 1000px;
    margin-left: auto;
    margin-right: auto
}
header{
    position: absolute;
    width: 100%;
    bottom: 30px;
    height: 80px;
    z-index: 9;
    line-height: 120px;
    .d-center-between{
        span{
            width: 19.5%;
            height: 65px;
            line-height: 65px;
            background-color: #fff;
            border-radius: 2px;
            font-size: 20px
        }
        span:hover{
            background-color:#12B2CB;
            color: #fff;
            cursor: pointer
        }
    }
    .font-weight-bold{
        background-color: rgba($color: #fff, $alpha: 0.8);
        height: 70px;
        line-height: 70px;
        margin-top: 10px;
        text-align: left
    }
}
</style>